function format_price(price) {
  if (price === undefined || price === null ) return;

    let parts = price.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return parts.join('.');
}

export {
    format_price
}
